import {UAParser} from 'ua-parser-js';

const {browser, device} = UAParser();

const isMobile = device.is('mobile') || device.is('tablet');

export const platform = {
  isAndroid: false,
  isIos: false,
  isMobileBrowser: isMobile,
  isNative: false,
  isSafari:
    browser.is('Safari') ||
    browser.is('Mobile Safari') ||
    // WebView
    (browser.is('WebKit') && isMobile),
  isWeb: true,
};
